import request from '@/utils/request'

// 查询微信小程序订阅消息分页
export function pageMiniSubscriptions(query) {
  return request({
    url: '/wx/mini/subscriptions/page',
    method: 'get',
    params: query
  })
}

// 查询微信小程序订阅消息列表
export function listMiniSubscriptions(query) {
  return request({
    url: '/wx/mini/subscriptions/list',
    method: 'get',
    params: query
  })
}

// 查询微信小程序订阅消息详细
export function getMiniSubscriptions(id) {
  return request({
    url: '/wx/mini/subscriptions/' + id,
    method: 'get'
  })
}

// 新增微信小程序订阅消息
export function addMiniSubscriptions(data) {
  return request({
    url: '/wx/mini/subscriptions',
    method: 'post',
    data: data
  })
}

// 修改微信小程序订阅消息
export function updateMiniSubscriptions(data) {
  return request({
    url: '/wx/mini/subscriptions',
    method: 'put',
    data: data
  })
}

// 删除微信小程序订阅消息
export function delMiniSubscriptions(id) {
  return request({
    url: '/wx/mini/subscriptions/' + id,
    method: 'delete'
  })
}

// 发送剧本上线订阅消息
export function sendScriptLaunch(data) {
  return request({
    url: '/wx/mini/subscriptions/send/script/launch',
    method: 'post',
    data: data
  })
}
